module.exports = __webpack_public_path__ + "static/media/linkOff.e1c35e33.svg";